// removed by extract-text-webpack-plugin
module.exports = {"wrap-breadcrumb":"wrap-breadcrumb","breadcrumb":"breadcrumb","breadcrumb-link":"breadcrumb-link","breadcrumb-slash":"breadcrumb-slash","news-breadcrumb":"news-breadcrumb"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_BreadCrumb.scss
// module id = ./components/layouts/master/sub-header/_BreadCrumb.scss
// module chunks = 0